module.exports = __webpack_public_path__ + "static/fonts/iconfont.18310dd.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/alfont/iconfont.ttf?t=1697420656926
// module id = l8dg
// module chunks = 84